import { ActivityItems } from '@/activity-feed/components/activity-items';
import {
  activityData as activityDataSelector,
  propertyData as propertyDataSelector,
} from '@/data/data-selectors';
import { ActivityFeedSkeleton } from '@/placeholders/skeleton-placeholders/activity-feed-skeleton';
import { ViolationSummaryNotes } from '@/property-details/components/content/violation-summary-notes';
import * as pd from '@/property-details/components/property-details-content-styles';
import { usePropertyDetails } from '@/utils/hooks/data/usePropertyDetails';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const AddressTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  color: #101938;
  margin-bottom: 38px;
  width: 100%;
`;

/**
 * Top level component for the Activity Feed tab content
 */
export function ActivityFeedContainer() {
  const { currentProperty, loading } = usePropertyDetails();

  const { listings } = currentProperty || {};

  const activityData = useSelector(activityDataSelector);
  const propertyData = useSelector(propertyDataSelector);

  if (loading) {
    return <ActivityFeedSkeleton />;
  }

  return (
    <pd.Wrapper>
      <pd.DetailsWrapper>
        <AddressTitle>{propertyData?.address}</AddressTitle>
      </pd.DetailsWrapper>

      <pd.DetailsWrapper>
        <ActivityItems activityData={activityData} />
        <pd.Spacer />
        <ViolationSummaryNotes listings={listings} />
      </pd.DetailsWrapper>
    </pd.Wrapper>
  );
}
